import { SxProps } from '@mui/material';

export const DpFanFinishStageFrameSx = (isPage: boolean): SxProps => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	backgroundColor: '#FFFFFF',
	borderTopLeftRadius: isPage ? '0px' : { xs: '16px', md: '0px' },
	borderTopRightRadius: isPage ? '0px' : { xs: '16px', md: '0px' },
	padding: { xs: '40px 30px', md: '0px' },
	position: 'relative',
	width: '100%',
	height: isPage ? '100%' : { xs: 'auto', md: '100%' },
});

export const DpFanFinishStageContentSx: SxProps = {
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	gap: { xs: '27px', md: '30px' },
};

export const DpFanFinishStageDataSx: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	maxWidth: { xs: '100%', md: '720px' },
	width: '100%',
};

export const DpFanFinishStageDataImageSx: SxProps = {
	width: { xs: '100%', md: '420px' },
	marginTop: { xs: '20px', md: '10px' },
};
